import { OrbitControls } from '@react-three/drei'
import Jake from './Jake.jsx'

export default function Experience()
{
    return <>

        <OrbitControls />

        <color args={[ '#000000']}  attach='background' />
        <fog attach='fog' args={[ '#244570', 1, 11 ]} />

        <directionalLight position={ [ 1, 2, 3 ] } intensity={ 5 }color={ '#531575' } />
        <ambientLight intensity={ 1.5 } />

        <Jake />

    </>
}